import React from 'react';
import { Wrench, Clock } from 'lucide-react';
import { API_BASE_URL } from '../config/api';

const BACKEND_URL = API_BASE_URL;

const MaintenancePage = ({ message, logoUrl, siteName }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* Site Logo */}
        {logoUrl && (
          <div className="mb-6">
            <img 
              src={logoUrl.startsWith('http') ? logoUrl : `${BACKEND_URL}${logoUrl}`}
              alt={siteName || 'Site Logo'}
              className="h-16 mx-auto object-contain"
            />
          </div>
        )}

        {/* Animated Icon */}
        <div className="mb-8 relative">
          <div className="w-24 h-24 mx-auto bg-amber-500/20 rounded-full flex items-center justify-center animate-pulse">
            <Wrench className="w-12 h-12 text-amber-500" />
          </div>
          <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2">
            <Clock className="w-8 h-8 text-gray-400 animate-bounce" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-4xl font-bold text-white mb-4">
          Bakım Çalışması
        </h1>

        {/* Message */}
        <p className="text-lg text-gray-300 mb-8 leading-relaxed">
          {message || "Sistemimiz şu anda bakım aşamasındadır. En kısa sürede hizmetinize geri döneceğiz. Anlayışınız için teşekkür ederiz."}
        </p>

        {/* Decorative dots */}
        <div className="flex justify-center gap-2 mb-8">
          <span className="w-2 h-2 bg-amber-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
          <span className="w-2 h-2 bg-amber-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
          <span className="w-2 h-2 bg-amber-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
        </div>

        {/* Admin Login Link - Hidden backdoor */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <a
            href="/login?bypass=admin"
            className="text-xs text-gray-600 hover:text-gray-400 transition-colors"
            data-testid="admin-backdoor-link"
          >
            Yönetici Girişi
          </a>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
